import {
    DisclaimerLayerAppearanceV2,
    LayerManagerV24,
} from '@volkswagen-onehub/layer-manager'
import React from 'react'
import {Provider} from 'react-redux'
import {DisclaimerVum} from '../DisclaimerVum'
import store from '../../../store'
import {ThemedLayerProvider} from '../../../../shared/ThemedLayerProvider'

function disclaimerLayer(): React.JSX.Element {
    return (
        <Provider store={store}>
            <ThemedLayerProvider theme="inverted">
                <DisclaimerVum />
            </ThemedLayerProvider>
        </Provider>
    )
}

let localLayerManager: LayerManagerV24
let layer: {close: () => void}

export const setDisclaimerLayerHandle = (layerManager: LayerManagerV24) => {
    localLayerManager = layerManager
}

export const openDisclaimerLayer = () => {
    layer = localLayerManager.openDisclaimerLayer(
        disclaimerLayer,
        {},
        {
            appearance: DisclaimerLayerAppearanceV2.DARK,
        }
    )
}

export const closeDisclaimerLayer = () => {
    layer.close()
}
